var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.19 49.4038L34.4325 45.1613L56.3525 67.0813C57.485 68.2138 58.9925 68.8388 60.595 68.8388C62.1975 68.8388 63.705 68.2138 64.8375 67.0813L86.7575 45.1613L91 49.4038L69.08 71.3238C66.8125 73.5913 63.8 74.8388 60.595 74.8388C57.39 74.8388 54.375 73.5913 52.11 71.3238L30.19 49.4038Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSDown);
export default __webpack_public_path__ + "static/media/Arrow_S_down.cca2b626.svg";
export { ForwardRef as ReactComponent };